import React from "react";

const colors = [
  // 清新蓝色系
  "#BBE6FF",
  "#8CD3FF",
  "#59BFFF",
  "#33ADFF",

  // 温柔粉色系
  "#FFD6E5",
  "#FFADC9",
  "#FF85AD",
  "#FF5C91",

  // 自然绿色系
  "#B2FFB2",
  "#80FF80",
  "#4DFF4D",
  "#1AFF1A",

  // 优雅紫色系
  "#E6CCFF",
  "#D699FF",
  "#C266FF",
  "#AD33FF",

  // 暖色调
  "#FFE0B2",
  "#FFCC80",
  "#FFB74D",
  "#FFA726",

  // 冷色调
  "#B3E5FC",
  "#81D4FA",
  "#4FC3F7",
  "#29B6F6",

  // 自然色系
  "#DCEDC8",
  "#C5E1A5",
  "#AED581",
  "#9CCC65",

  // 高饱和度渐变色系
  "#90CAF9",
  "#64B5F6",
  "#42A5F5",
  "#2196F3", // 渐变蓝
  "#CE93D8",
  "#BA68C8",
  "#AB47BC",
  "#9C27B0", // 渐变紫
  "#A5D6A7",
  "#81C784",
  "#66BB6A",
  "#4CAF50", // 渐变绿

  // 流行色系
  "#FFCC80",
  "#FFB74D",
  "#FFA726",
  "#FF9800", // 日落橙
  "#F48FB1",
  "#F06292",
  "#EC407A",
  "#E91E63", // 玫瑰粉
  "#B39DDB",
  "#9575CD",
  "#7E57C2",
  "#673AB7", // 薰衣草紫

  // 珐琅色系
  "#B8D4FF",
  "#9CC2FF",
  "#80B0FF",
  "#669EFF", // 天青珐琅
  "#FFB8B8",
  "#FF9999",
  "#FF7A7A",
  "#FF5C5C", // 胭脂珐琅
  "#B8FFB8",
  "#99FF99",
  "#7AFF7A",
  "#5CFF5C", // 翠绿珐琅
  "#FFD4BA",
  "#FFC4A0",
  "#FFB485",
  "#FFA46B", // 赤金珐琅
];

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="flex flex-wrap gap-2 sm:gap-3 max-w-full sm:max-w-4xl mx-auto">
      {colors.map((color, index) => (
        <button
          key={`color-${color}-${index}`}
          className={`w-6 h-6 sm:w-8 sm:h-8 rounded-full border-2 transition-transform hover:scale-110 ${
            color === value ? "scale-110" : "border-transparent"
          }`}
          style={{
            backgroundColor: color,
            boxShadow:
              color === value ? "0 0 0 2px rgba(59, 130, 246, 0.2)" : "none",
          }}
          onClick={() => onChange(color)}
        />
      ))}
    </div>
  );
};
